import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@mui/styles';
import {
  Button, ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid, TextField, Typography
} from '@mui/material';
import {licensingService} from "../../../../../store/services";
import { useDispatch } from 'react-redux';
import { history } from '../../../../../helpers/history';
import { GridItem } from '../../../../../components/Grid';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';

const useStyles = makeStyles(theme => ({
  root: {
    actions: {
      justifyContent: 'flex-end'
    },
  },
  item: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    minHeight: '100%',
    padding: 0,
  },
  titleHeader: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.white
  },
  title: {
    fontSize: "large"
  },
  subheader: {
    color: theme.palette.white
  },
  button: {
    color: theme.palette.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light

    }
  },
  icon: {
    height: 32,
    width: 32,
    color: theme.palette.primary.main
  },
  action: {
    margin: 0
  }
}));

const LicenseLoad = props => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const getPublicKey = () => {
    return licensingService.readPublicKey()
      .then(
        response => {
          return (response.data.publicKey)
        }
      )
      .catch(
        error => {
          console.log(error);
        }
      );
  }

  const onHandleChange = () => {
    alert("on Handle Change");
  }

  return (
    <Card>
      <form>
        <CardHeader
          className={classes.titleHeader}
          classes={{
            action: classes.action,
            subheader: classes.subheader,
            title: classes.title
          }}
          subheader="New License Request"
          title="MISSING LICENSE"
        />
        <Divider />
        <CardContent>
          <CardActions>
            <GridItem
              md={2}
              xs={12}
            >
              <div className="Upload">
                <form
                  encType="multipart/form-data"
                  method="post"
                >
                  <label htmlFor="select-file">
                    {/*{(fileList.length === 0) &&*/}
                      <div>
                        <input
                          accept="signtaure.bin,maestro-licensefile.txt"
                          id="select-file"
                          multiple="multiple"
                          name="select-file[]"
                          onChange={onHandleChange}
                          style={{display: 'none'}}
                          type="file"
                        />
                        <Button
                          color="primary"
                          className={classes.button}
                          component="span"
                          variant="contained"
                        >
                          <AddIcon/> Browse
                        </Button>
                      </div>
                    {/*}*/}
                  </label>
                </form>
              </div>
            </GridItem>
          </CardActions>
        </CardContent>
      </form>
    </Card>
  );
};

LicenseLoad.propTypes = {
  className: PropTypes.string
};

export default LicenseLoad;
